<oaibox-stats-card
  title="Bill of Materials"
  icon="fa-solid fa-cart-minus"
  gradient="secondary"
>
  <ul class="bill-of-materials-items-list">
    @for (item of order.bom; track item.name) {
      <li class="bill-of-materials-item">
        <span>{{ item.quantity + "x " + item.name }}</span>
      </li>
    }
  </ul>

  <div class="download-row">
    <a class="download-link" (click)="downloadBillOfMaterials()">
      <i class="fa-solid fa-download"></i> Download data
    </a>
  </div>
</oaibox-stats-card>
